"use client";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const notificationContainerStyles = {
  marginBottom: SpaceMd
};
const notificationContentStyles = {
  wordBreak: "break-word",
  overflowWrap: "break-word",
  whiteSpace: "normal"
};
export {
  notificationContainerStyles,
  notificationContentStyles
};
